import React, { useState } from 'react';
import CardImageHorizontal from './CardImageHorizontal';
import CardInfo from './CardBaseTransport';
import AccommodationForm from './AccommodationForm';
import './Cards1.css';
import { useLang } from '../i18n';

function Accomodation() {
  const { t } = useLang();
  const [showBooking, setShowBooking] = useState(false);
  return (
    <div>
      <div className='cards__next'>
        <h1>{t('info.accomTitle')}</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                  <CardInfo 
                    text1={t('info.accomOrder')}
                    text2={t('info.accomPayment')} 
                    footer={
                      <button
                        className='btn-book-card'
                        onClick={() => setShowBooking(true)}
                      >
                        {t('hero.book')} <i className='fas fa-bed' />
                      </button>
                    }
               />
               </ul>
               {showBooking && <AccommodationForm onClose={() => setShowBooking(false)} />}

                <ul className='cards__items'>
                    <CardImageHorizontal
                    src='images/hotelMsport.jpg'
                    tag={t('info.breakfastIncluded')}
                    label='Penzión ARENA'
                    address='Ostrov 363, 911 05 Trenčín'
                    price1={t('info.doubleRoom85')}
                    price2={t('info.tripleRoom100')}
                    price3={t('info.fourRoom110')}
                    distance={t('info.distVenue')}
                    />
                    </ul>
                    <ul className='cards__items'>
                    <CardImageHorizontal
                    src='images/hotelPodHradom.jpg'
                    tag={t('info.breakfastIncluded')}
                    label='Hotel Pod Hradom ★★★'
                    address='Matúšova 12, 911 01 Trenčín'
                    price1={t('info.doubleRoom95')}
                    price3={t('info.tripleRoom110')}
                    distance={t('info.dist14')}
                    />
                    </ul>
                    <ul className='cards__items'>
                    <CardImageHorizontal
                    src='images/hotelGaborik.jpg'
                    tag={t('info.breakfastIncluded')}
                    label='Hotel of Marián Gáborík ★★★'
                    address='Hodžova 6844, 911 01 Trenčín'
                    price1={t('info.singleRoom65')}
                    price2={t('info.doubleRoom95')}
                    price3={t('info.tripleRoom110')}
                    distance={t('info.dist19')}
                    />
                    </ul>
                    <ul className='cards__items'>
                    <CardImageHorizontal
                    src='images/hotelCityCentre.jpeg'
                    tag={t('info.breakfastIncluded')}
                    label='Apartments in city-centre'
                    address='Matúšova 10, 911 01 Trenčín'
                    price3={t('info.apartment170')}
                    description={t('info.apartmentDesc') + ' ' + t('info.apartmentMinStay')}
                    distance={t('info.dist14')}
                    />
                </ul>
            </div>
        </div>
      </div>
    </div>
  );
}

export default Accomodation;